import React, {  Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { checkServicePrices, saveCreateWorkOrderPayload } from '../../redux/actions';

class AddServicesForWorkOrderDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false,
			availableServices: [],
            errorMessage: '',
            otherServices: []
        } 
    }
    
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false,
            showNextButton: false,
        });
		this.props.handleDialog('AddServicesForWorkOrderDialog',false,null);
    }
    
	componentDidMount() {
		const self = this;
        const availableServices = self.props.availableServices;
        self.props.saveCreateWorkOrderPayload(self.props.orderDetails);
        availableServices.forEach(item => {
            item.quantity = 1;
            if (item.service === 'M010') {
                item.selected = true;
            }
        });
		self.setState({
            showDialog: self.props.showDialog,
			availableServices: _.orderBy(availableServices.filter(item => item.service !== 'M038'), ['service'], ['asc'])
        });
	}

	handleNext(event) {
        const self = this;
		event.preventDefault();
        const { availableServices, otherServices } = self.state;
        let selectedServices = availableServices.concat(otherServices).filter(item => item.selected);
        let formError = false;
        let errorMessage = '';
        availableServices.forEach(item => {
            if (item.selected && (!item.quantity || item.quantity < 0)) {
                item.quantityError = 'error';
                formError = true;
            } else {
                item.quantityError = '';
            }
        });
        otherServices.forEach(item => {
            if (item.selected && (!item.quantity || item.quantity < 0)) {
                item.quantityError = 'error';
                formError = true;
            } else {
                item.quantityError = '';
            }
        });
        if (selectedServices.length === 0) {
            formError = true;
            errorMessage = "Please select atleast one service.";
        }
        self.setState({
            errorMessage,
            otherServices,
            availableServices
        });
        if (!formError) {
            selectedServices = _.cloneDeep(selectedServices);
            selectedServices.forEach(item => {
                if (item.waiveSelected) {
                    item.servicePrice = 0;
                }
            });
            self.props.saveCreateWorkOrderPayload({ ...self.props.orderDetails, items: selectedServices });
            browserHistory.push(`/order/createworkorder`);
            self.closeDialog(event);
        }
	}

    handleWaive(index, event) {
        const self = this;
        const availableServices = self.state.availableServices;
        availableServices[index].waiveSelected = event.target.checked;
        self.setState({
            availableServices,
        });
    }
    handleWaiveOtherServices(index, event) {
        const self = this;
        const otherServices = self.state.otherServices;
        otherServices[index].waiveSelected = event.target.checked;
        self.setState({
            otherServices,
        });
    }

    onChangeUpdateQuantity(index, event) {
        const self = this;
        const availableServices = self.state.availableServices;
        availableServices[index].quantity = event.target.value;
        availableServices[index].quantityError = '';
        self.setState({
            availableServices,
            errorMessage: '',
        });
    }

    onChangeUpdateOtherServiceQuantity(index, event) {
        const self = this;
        const otherServices = self.state.otherServices;
        otherServices[index].quantity = event.target.value;
        otherServices[index].quantityError = '';
        self.setState({
            otherServices,
            errorMessage: '',
        });
    }
    
	handleSelectService(index, event) {
		const self = this;
        const availableServices = self.state.availableServices;
        availableServices[index].selected = event.target.checked;
        self.setState({
            availableServices,
            errorMessage: '',
        });
	}
    handleSelectOtherServices(index, event) {
        const self = this;
        const otherServices = self.state.otherServices;
        otherServices[index].selected = event.target.checked;
        self.setState({
            otherServices,
            errorMessage: '',
        });
    }

    handleAddService(event) {
		event.preventDefault();
        const  { otherServices } = this.state;
        otherServices.push({
            item: '',
            price: '',
            itemDescription: '',
            quantity: 1,
            extendedPrice: '',
            serviceError:'',
            errorMessage:'',
			isCustomService: true,
        })
		this.setState({
            otherServices
        }, () => {
            var myVar = setInterval(function(){
    			var div = document.getElementById("addServiceContainer");
    			div.scrollTop = div.scrollHeight - div.clientHeight + 43;
    			clearInterval(myVar);
    		}, 200);
        });
	}

    handleChangeCustomService(index, event) {
        const self = this;
        const { otherServices } = self.state;
        const service = event.target.value.toUpperCase();
        otherServices[index].service = service;
        otherServices[index].serviceError = '';
        otherServices[index].errorMessage = '';
        self.setState({
            otherServices
        }, () => {
            if (service.length === 4) {
                if (service.indexOf('M') === 0 && service !== 'M038') {
                    if (this.state.availableServices.find(itm => itm.service === service)) {
                        const { otherServices } = self.state;
                        otherServices[index].serviceError = 'error';
                        otherServices[index].errorMessage = 'Service already added';
                        self.setState({
                            otherServices
                        });
                    } else {
                        const requiredPayloadForServicePricing = self.props.requiredPayloadForServicePricing;
                        const servicesPayload = [{
                            ...requiredPayloadForServicePricing,
                            itemNumber: service
                        }];
                        // Get all orderable services prices list
                        self.props.checkServicePrices({items: servicesPayload}, "requestType=servicesPricing", resp => {
                            const { otherServices } = self.state;
                            if(resp.status) {
                                let unitPrice = null;
                                let description = null;
                                resp.responseObject = JSON.parse(resp.responseObject);
                                if (resp.responseObject.items[0].unitPrice) {
                                    unitPrice = resp.responseObject.items[0].unitPrice;
                                    description = resp.responseObject.items[0].description;
                                    self.props.checkServicePrices({ ...requiredPayloadForServicePricing, itemNumber: service },"requestType=itemStatus", itemStatus => {
                                        if(itemStatus.responseObject === "Active") {
                                            self.props.checkServicePrices({ ...requiredPayloadForServicePricing, itemNumber: service },"requestType=itemOrderabilityFlag", itemOrderabilityFlag => {
                                                if(itemOrderabilityFlag.responseObject === "Y") {
                                                    otherServices[index].servicePrice = unitPrice;
                                                    otherServices[index].serviceDescription = description;
                                                    otherServices[index].isValidService = true;
                                                    self.setState({
                                                        otherServices
                                                    });
                                                } else {
                                                    otherServices[index].serviceError = 'error';
                                                    otherServices[index].errorMessage = 'Service not offered in this zip code';
                                                    self.setState({
                                                        otherServices
                                                    });
                                                }
                                            });
                                        } else {
                                            otherServices[index].serviceError = 'error';
                                            otherServices[index].errorMessage = 'Service not offered in this zip code';
                                            self.setState({
                                                otherServices
                                            });
                                        }
                                    });
                                } else {
                                    otherServices[index].serviceError = 'error';
                                    otherServices[index].errorMessage = 'Pricing not found';
                                    self.setState({
                                        otherServices
                                    });
                                }
                            } else {
                                otherServices[index].serviceError = 'error';
                                otherServices[index].errorMessage = 'Pricing not found';
                                self.setState({
                                    otherServices
                                });
                            }
                        });
                    }
                } else {
                    const { otherServices } = self.state;
                    otherServices[index].serviceError = 'error';
                    otherServices[index].errorMessage = 'Invalid service';
                    self.setState({
                        otherServices
                    });
                }
            }
        });
    }
    
    render() {
		const self = this;
        const isThereAnyServices = self.state.availableServices.length + self.state.otherServices.length;
        const isGEUser = self.props.state.user.userDetails.typeOfUser === 'employee';
        return (
            <div className="overlayDialog" id="addServicesOverlayDialog" style={{visibility: (self.state.showDialog===true?'visible':'hidden')}}>
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton fontSize-10" onClick={self.closeDialog.bind(this)}>×</a>
                    <div className="push">
                        <h2 className="title">Create Work Order</h2>
                    </div>
                    <div>
                        <h3 className="title">Add Services</h3>
                        {!isThereAnyServices
                            ?<p>Services available for: <b>{self.props.selectedSKU}</b></p>
                            :null
                        }
                        {self.state.errorMessage && <p className="red bold">{self.state.errorMessage}</p>}
                        {!isThereAnyServices
                            ?<p style={{color: '#092c74'}} className="bold">No services available for this product</p>
                            :null
                        }
                    </div>
                    <form className="addServicesForm" name="addServicesForm" id="addServicesForm" action="">
                        {isThereAnyServices
                            ? <div>
                                <div id="addServiceContainer" style={{height: 200, overflow: 'scroll'}}>
                                    <table className="dataTableType2 addServicesTable">
                                        <thead>
                                            <tr>
                                                <th className="select">Select</th>
                                                <th className="service">Service</th>
                                                <th className="price">Price<span className="unbold">(Each)</span></th>
                                                <th className="quantity">Quantity</th>
                                                {isGEUser && <th className="waive">Waive</th>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.availableServices.map((item, index) => {
                                                return <tr key={index}>
                                                    <td className="select">
                                                        <input type="checkbox" 
                                                            checked={item.selected}
                                                            disabled={item.service === "M010"} 
                                                            onChange={this.handleSelectService.bind(this, index)}
                                                        />
                                                    </td>
                                                    <td className="service">
                                                        {item.service}&nbsp;— {item.serviceDescription}
                                                    </td>
                                                    <td className="price">
                                                        {self.props.formatAmount2Decimal(item.servicePrice)}
                                                    </td>
                                                    <td className={`row_quantity ${item.service==="M010" ? "txt-ctr" : ""}`}>
                                                        {item.service==="M010"
                                                            ? item.quantity
                                                            : <input
                                                                id={"quantity"+index}
                                                                type="text"
                                                                name="quantity"
                                                                className={`itemQuantity ${item.quantityError}`}
                                                                onKeyPress={this.props.acceptNumbersOnly}
                                                                onPaste={this.props.doNothing}
                                                                onBlur={event => !event.target.value}
                                                                onChange={this.onChangeUpdateQuantity.bind(this, index)}
                                                                value={item.quantity}
                                                                size={1}
                                                            />
                                                        }
                                                    </td>
                                                    {isGEUser && <td className="waive">
                                                        <input type="checkbox"  onChange={this.handleWaive.bind(this, index)} />
                                                    </td>}
                                                </tr>
                                            })}
                                            {this.state.otherServices.map((item, index) => {
                                                return <tr key={index}>
                                                    <td className="select">
                                                        <input type="checkbox" disabled={!item.isValidService} checked={item.selected} onChange={this.handleSelectOtherServices.bind(this, index)} />
                                                    </td>
                                                    <td className="service">
                                                        {item.isValidService
                                                            ? `${item.service} — ${item.serviceDescription}`
                                                            : <input type="text" className={item.serviceError} maxLength={4} value={item.service} name={`service${index}`} onChange={this.handleChangeCustomService.bind(this, index)} />
                                                        }
                                                        {item.errorMessage && <span className="red"><br />{item.errorMessage}</span>}
                                                    </td>
                                                    <td className="price">
                                                        {self.props.formatAmount2Decimal(item.servicePrice)}
                                                    </td>
                                                    <td className="quantity">
                                                        <input
                                                            id={"quantity"+index}
                                                            type="text"
                                                            name="quantity"
                                                            required="true"
                                                            className={`itemQuantity ${item.quantityError}`}
                                                            onKeyPress={this.props.acceptNumbersOnly}
                                                            onPaste={this.props.doNothing}
                                                            value={item.quantity}
                                                            onChange={this.onChangeUpdateOtherServiceQuantity.bind(this, index)}
                                                            size={1}
                                                        />
                                                    </td>
                                                    {isGEUser && <td className="waive">
                                                        <input type="checkbox" onChange={this.handleWaiveOtherServices.bind(this, index)} />
                                                    </td>}
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                                <p>
                                    <a className="bold noUnderline uppercase addProductLink fontSize-10" href="" onClick={this.handleAddService.bind(this)}>+ <u>Add Service</u></a>
                                </p>
                                <div>
                                    <div className="noButtonContainer">
                                        <a className="noButton blueButton fontSize-10" onClick={self.closeDialog.bind(this)}>Cancel</a>
                                    </div>
                                   <div className="yesButtonContainer">
                                        <a className="blueButton yesButton fontSize-10" onClick={self.handleNext.bind(this)}>Next</a>
                                    </div>
                                </div>
                            </div>
                            : <div>
                                <p>
                                    <a className="bold noUnderline uppercase addProductLink fontSize-10" href="" onClick={this.handleAddService.bind(this)}>+ <u>Add Service</u></a>
                                </p>
                                <div className="yesButtonContainer">
                                    <a className="blueButton yesButton fontSize-10" onClick={self.closeDialog.bind(this)}>Ok</a>
                                </div>
                            </div>
                        }
                    </form>
                </div>
        </div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	checkServicePrices: (payload, params, response) => dispatch(checkServicePrices(payload, params, response)),
    saveCreateWorkOrderPayload: (payload) => dispatch(saveCreateWorkOrderPayload(payload)),
});

AddServicesForWorkOrderDialog = connect(mapStateToProps, mapDispatchToProps)(AddServicesForWorkOrderDialog);
export default AddServicesForWorkOrderDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/addServicesForWorkOrderDailog.js